var h = Object.create,
  e = Object.defineProperty,
  i = Object.getOwnPropertyDescriptor,
  j = Object.getOwnPropertyNames,
  k = Object.getPrototypeOf,
  l = Object.prototype.hasOwnProperty,
  m = (t, a, r) => a in t ? e(t, a, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: r
  }) : t[a] = r,
  n = t => e(t, "__esModule", {
    value: !0
  }),
  r = (t, a) => e(t, "name", {
    value: a,
    configurable: !0
  }),
  s = (e, t) => () => (e && (t = e(e = 0)), t),
  t = (e, t) => () => (t || e((t = {
    exports: {}
  }).exports, t), t.exports),
  o = (t, a, r) => {
    if (a && "object" == typeof a || "function" == typeof a) for (let o of j(a)) !l.call(t, o) && "default" !== o && e(t, o, {
      get: () => a[o],
      enumerable: !(r = i(a, o)) || r.enumerable
    });
    return t;
  },
  u = t => o(n(e(null != t ? h(k(t)) : {}, "default", t && t.__esModule && "default" in t ? {
    get: () => t.default,
    enumerable: !0
  } : {
    value: t,
    enumerable: !0
  })), t),
  v = (e, t, a) => (m(e, "symbol" != typeof t ? t + "" : t, a), a),
  f = (e, t, a) => {
    if (!t.has(e)) throw TypeError("Cannot " + a);
  },
  p = (e, t, a) => (f(e, t, "read from private field"), a ? a.call(e) : t.get(e)),
  w = (e, t, a) => {
    if (t.has(e)) throw TypeError("Cannot add the same private member more than once");
    t instanceof WeakSet ? t.add(e) : t.set(e, a);
  },
  q = (e, t, a, r) => (f(e, t, "write to private field"), r ? r.call(e, a) : t.set(e, a), a),
  x = (e, t, a, r) => ({
    set _(r) {
      q(e, t, r, a);
    },
    get _() {
      return p(e, t, r);
    }
  }),
  y = (e, t, a) => (f(e, t, "access private method"), a);
export { r as a, s as b, t as c, u as d, v as e, p as f, w as g, q as h, x as i, y as j };